import { Dispatch, SetStateAction } from 'react'

import { Box } from '@chakra-ui/react'

import FullWidthDivider from 'src/components/widgets/FullWidthDivider/FullWidthDivider'
import LockSwitch from 'src/components/widgets/LockSwitch/LockSwitch'

const CreatorHeader: React.FC<{
  locked: boolean
  setLocked: Dispatch<SetStateAction<boolean>>
}> = ({ locked, setLocked }) => (
  <Box
    position="relative"
    w={{ base: 'full', lg: '744px' }}
    m="0 auto"
    bg="white"
  >
    <LockSwitch setLocked={setLocked} locked={locked} maxW="500px" m="0 auto" />
    <FullWidthDivider />
  </Box>
)

export default CreatorHeader
